/**
 * Loads the IBM Plex families every screen renders with.
 *
 * The app shell and the Storybook preview both need the fonts and nothing else
 * from `instance`, so the hook lives here instead. Storybook's visual
 * regression derives which stories to re-render from what the preview imports;
 * importing `instance` there would add its screen-resolution pipeline, and the
 * structures that pipeline reaches, to every story's dependencies.
 */

import { IBMPlexMono_400Regular } from '@expo-google-fonts/ibm-plex-mono/400Regular';
import { IBMPlexMono_500Medium } from '@expo-google-fonts/ibm-plex-mono/500Medium';
import { IBMPlexMono_600SemiBold } from '@expo-google-fonts/ibm-plex-mono/600SemiBold';
import { IBMPlexSans_400Regular } from '@expo-google-fonts/ibm-plex-sans/400Regular';
import { IBMPlexSans_500Medium } from '@expo-google-fonts/ibm-plex-sans/500Medium';
import { IBMPlexSans_600SemiBold } from '@expo-google-fonts/ibm-plex-sans/600SemiBold';
import { useFonts } from 'expo-font';

export function useStandardFonts() {
    const [fontsLoaded] = useFonts({
        IBMPlexSans_400Regular,
        IBMPlexSans_500Medium,
        IBMPlexSans_600SemiBold,
        IBMPlexMono_400Regular,
        IBMPlexMono_500Medium,
        IBMPlexMono_600SemiBold,
    });
    return fontsLoaded;
}
